import { render, staticRenderFns } from "./SalesFreightInformation.vue?vue&type=template&id=18c82158&scoped=true"
import script from "./SalesFreightInformation.vue?vue&type=script&lang=js"
export * from "./SalesFreightInformation.vue?vue&type=script&lang=js"
import style0 from "./SalesFreightInformation.vue?vue&type=style&index=0&id=18c82158&prod&scoped=true&lang=css"
import style1 from "./SalesFreightInformation.vue?vue&type=style&index=1&id=18c82158&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c82158",
  null
  
)

export default component.exports